import { gql } from "graphql-request";

export const GET_AGENCIES_SALES_DETAILS = gql`
  query GetAgenciesSalesDetails(
    $take: Int
    $skip: Int
    $userId: Int
    $dateInitial: String
    $dateFinal: String
  ) {
    getAgenciesSalesDetails(
      take: $take
      skip: $skip
      userId: $userId
      dateInitial: $dateInitial
      dateFinal: $dateFinal
    ) {
      status
      error
      data {
        id
        agencyId
        userId
        coins
        dateSentCoin
        dateReceivedCoin
        createdAt
        userUsername
        userImgUser
        reversedAt
        isAgency
      }
    }
  }
`;

export const GET_AGENCIES_SALES_DETAILS_TOTAL = gql`
  query GetAgenciesSalesDetailsTotal(
    $dateTimeInitial: String
    $dateTimeFinal: String
  ) {
    getAgenciesSalesDetailsTotal(
      dateTimeInitial: $dateTimeInitial
      dateTimeFinal: $dateTimeFinal
    ) {
      status
      error
      data {
        total
        count
      }
    }
  }
`;

// ⚠️ O gateway espalha `body.variables` cru pro worker: o nome da variável
// GraphQL TEM que bater com o nome do argumento (`$saleId` -> `saleId`).
export const REVERSE_AGENCY_SALE_DETAIL = gql`
  mutation REVERSE_AGENCY_SALE_DETAIL($saleId: Int!) {
    reverseAgencySaleDetail(saleId: $saleId) {
      error
      status
      data {
        id
        coins
        reversed
      }
    }
  }
`;

export const CREATE_AGENCY_SALE_DETAIL = gql`
  mutation CREATE_AGENCY_SALE_DETAIL(
    $agencyId: Int!
    $userId: Int!
    $coins: Float!
    $isAgency: Boolean!
  ) {
    createAgencySaleDetail(
      agencyId: $agencyId
      userId: $userId
      coins: $coins
      isAgency: $isAgency
    ) {
      error
      status
      data
    }
  }
`;
